/**
 * Parse SaaS Foundation API errors — including structured upgrade_required payloads.
 */

export function parseApiErrorDetail(detail) {
  if (!detail) {
    return { message: 'Request failed', upgradeRequired: false };
  }
  if (typeof detail === 'string') {
    return { message: detail, upgradeRequired: false };
  }
  return {
    message: detail.message || 'Request failed',
    code: detail.code || null,
    upgradeRequired: Boolean(detail.upgrade_required),
    currentPlan: detail.current_plan || null,
  };
}

/**
 * Read a failed fetch Response and return an Error with upgrade metadata attached.
 */
export async function readApiError(response, fallback = 'Request failed') {
  const data = await response.json().catch(() => ({}));
  const parsed = parseApiErrorDetail(data.detail);
  const err = new Error(parsed.message || fallback);
  err.upgradeRequired = parsed.upgradeRequired;
  err.code = parsed.code;
  err.currentPlan = parsed.currentPlan;
  return err;
}

export const UPGRADE_ERROR_CODES = new Set([
  'SEAT_LIMIT_REACHED',
  'ROLE_NOT_ENTITLED',
  'LOCATION_LIMIT_REACHED',
  'USAGE_LIMIT_REACHED',
  'NO_ACTIVE_SUBSCRIPTION',
]);
